import {Observable} from "rxjs";
import {RestApiService} from '../../../rest-api.service';
import {NoteCreateReq, NoteDetailRes, NoteUpdateReq} from '../../../../contracts/v0/crm';
import {ApiV0Crm} from '../api.v0.crm';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

export class ApiV0CrmNote {
    segment = '/note'

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<NoteDetailRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<NoteDetailRes>>(
            `${this.segment}/search`,
            NoteDetailRes,
            searchModel
        )
    }

    detail(id: number): Observable<NoteDetailRes> {
        return this.rest.get<NoteDetailRes>(
            `${this.segment}/${id}`,
            NoteDetailRes
        )
    }

    create(createReq: NoteCreateReq) {
        return this.rest.post<NoteCreateReq, NoteDetailRes>(
            `${this.segment}/`,
            NoteDetailRes,
            createReq
        )
    }

    delete(note: NoteDetailRes) {
        return this.rest.delete<NoteDetailRes>(
            `${this.segment}/${note.id}`
        )
    }

    update(note: NoteUpdateReq) {
        return this.rest.patch<NoteUpdateReq, NoteDetailRes>(`${this.segment}`, NoteDetailRes, note)
    }
}
